/**
 * Tiny dev-only logger. In production builds (NODE_ENV=production)
 * these helpers are no-ops, so we never leak debug info to end users.
 */
const DEV = process.env.NODE_ENV !== "production";

export const devLog = (...args) => { if (DEV) console.log(...args); };
export const devWarn = (...args) => { if (DEV) console.warn(...args); };
export const devError = (...args) => { if (DEV) console.error(...args); };
